import { HttpService } from '@/infra/http'

import type { TGetEmpreendimentosFilters, TGetEmpreendimentosResponse } from '../interfaces/empreendimento.types'

export class GetEmpreendimentosService extends HttpService {
  execute = async (filtros: TGetEmpreendimentosFilters) => {
    return this.http.get<TGetEmpreendimentosResponse>(`api/v2/Empreendimento`, { params: filtros })
  }
}
